import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogFlagDetails, ActivityLogTaskFlagAdded_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskFlagAdded_ActivityLogFragment;
}

const ActivityLogTaskFlagAdded: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;

  const { flagContent } = details as ActivityLogFlagDetails;

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.flaggedTaskAsNeeding"
      actionLabelValues={{ flagContent }}
    />
  );
};

ActivityLogTaskFlagAdded.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskFlagAdded_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogFlagDetails {
          flagContent
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskFlagAdded;
